import { render } from "./BiasSorter.vue?vue&type=template&id=2d1afe35&scoped=true"
import script from "./BiasSorter.vue?vue&type=script&lang=js"
export * from "./BiasSorter.vue?vue&type=script&lang=js"

import "./BiasSorter.vue?vue&type=style&index=0&id=2d1afe35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1afe35"]])

export default __exports__